<template>
  <div class="banner-wrap">
    <div class="banner-image">
      <template v-if="bottomLink()">
        <a href="#" @click.prevent="goDetail(bottomLink())" :target="bottomTarget()">
          <img :src="bottomImage()" :alt="bottomText1()"/>
        </a>
      </template>
      <template v-else>
        <img :src="bottomImage()" :alt="bottomText1()"/>
      </template>
    </div>
    <div v-if="bannerDesc.length && bannerDesc.length > 0">
      <button type="button" @click.prevent="toggleEventInfo" :class="'banner-event ' + eventClass">
        이벤트 내용을 확인하세요
      </button>
      <div class="event-exclamation" v-if="eventToggle">
        <ul>
          <li v-for="(text, index) in bannerDesc" :key="'bannerDescription_' + index">{{text}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { VoucherService } from '@/common/api/api.service'
import { get } from 'lodash'
import utils from '@/common/util/utils'
import { bannerLink } from '@/common/util/common'
export default {
  name: 'VoucherBanner',
  components: {

  },
  data () {
    return {
      eventToggle: false,
      eventClass: 'event-open',
      bannerInfo: null,
      bannerDesc: [],
      device: utils.cookies.getDevice(),
      isLogin: utils.cookies.getCredential() !== 'none'
    }
  },
  props: {
    bannerId: {
      type: String
    },
    bannerJsonUrl: {
      type: String,
      default: ''
    }
  },
  methods: {
    bottomLink () {
      return get(this.bannerInfo, ['band', 'celllist', '0', 'event_list', '1', 'url'], '')
    },
    bottomText1 () {
      return get(this.bannerInfo, ['top_list', '0', 'bottom_list', '0', 'bottom_text1'], '')
    },
    bottomText2 () {
      let text2 = get(this.bannerInfo, ['band', 'celllist', '0', 'title_list', '0', 'text'], '')
      if (text2) text2 = text2.replace('$O$', '<span class="title-dot"></span>')
      return text2
    },
    bottomText3 () {
      return get(this.bannerInfo, ['top_list', '0', 'bottom_list', '0', 'bottom_text3'], 0)
    },
    bottomImage () {
      if (get(this.bannerInfo, ['band', 'celllist', '0', 'thumbnail'], '')) {
        return 'https://' + get(this.bannerInfo, ['band', 'celllist', '0', 'thumbnail'], '')
      }
    },
    bottomTarget () {
      return '_self'
    },
    toggleEventInfo () {
      this.eventToggle = !this.eventToggle
      this.eventClass = this.eventToggle ? 'event-close' : 'event-open'
    },
    goDetail (url) {
      bannerLink(url)
    }
  },
  created () {
    let bannerData = {}
    if (this.bannerJsonUrl !== '') {
      if (this.bannerId === 'oksusu' && !this.isLogin) return
      const timeStamp = new Date().getTime()
      bannerData = VoucherService.PromotionBanner({ url: this.bannerJsonUrl + '?timeStamp= ' + timeStamp })
    } else {
      bannerData = VoucherService.getBannerImage({ bannerId: this.bannerId })
    }
    this.$nextTick(() => {
      bannerData.then(({ data }) => {
        this.bannerInfo = data
        const bottomListCount = get(this.bannerInfo, ['band', 'celllist'], []).length
        if (bottomListCount && this.bottomImage() && this.bottomText2()) {
          this.bannerDesc = this.bottomText2().split(/\r\n|\n|\r/g)
        }
      })
    })
  }
}
</script>

<style scoped>

</style>
